/**
 * Where the hub's API is mounted: the same origin as the SPA (the server serves the built client;
 * Vite proxies `/api` in dev), so every path is relative.
 */
export const API_BASE = '/api';

/** The tRPC endpoint `App.tsx`'s batch link calls. */
export const TRPC_PATH = `${API_BASE}/trpc`;

/** The runtime configuration `config/AppConfig.tsx` fetches before anything renders. */
export const APP_CONFIG_PATH = `${API_BASE}/config.json`;
